// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupContentInfo_wrapper__U4SkK","box":"PopupContentInfo_box__3gKkS"};